<template>
	<div class="action-resources-page__file-container d-flex">
		<div class="d-flex">
			<div class="d-flex align-center">
				<PostAttachments :attachment="fileAttachment" backgroundColor="#F3F3F6" />
			</div>
			<div class="action-resources-page__file-container__wrapper">
				<a
					class="action-resources-page__file-container__wrapper__title"
					:href="fileUrl"
					target="_blank"
				>
					{{ fileName }}
				</a>
				<span class="action-resources-page__file-container__wrapper__description">
					{{ fileDescription }}
				</span>
			</div>
		</div>
		<span class="action-resources-page__file-container__wrapper__date mt-2">
			{{ dateCreated(fileDate) }}
		</span>
	</div>
</template>
<script>
import PostAttachments from '@/components/Post/PostAttachments.vue'

export default {
	name: 'FileListComponent',
	props: {
		attachment: {
			type: Object,
			default: () => ({}),
		},
	},
	components: { PostAttachments },
	computed: {
		fileUrl() {
			return this.attachment?.upload?.url || this.attachment?.url || ''
		},
		fileName() {
			return this.attachment?.file_real_name || this.attachment?.upload?.file_real_name || this.attachment?.filename || ''
		},
		fileAttachment() {
			return this.attachment.upload || this.attachment
		},
		fileDescription() {
			return (
				this.attachment?.file_description || this.attachment?.upload?.file_description || ''
			)
		},
		fileDate() {
			return this.attachment?.files_release_date || this.attachment?.time ||''
		},
	},
	methods: {
		dateCreated(originalDate) {
			const date = new Date(originalDate * 1000)
			return date.toLocaleString('en-US', {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
				timeZone: 'UTC',
			})
		},
	},
}
</script>

<style lang="scss">
.action-resources-page {
	user-select: unset !important;
	&__file-container {
		padding: 12px;
		background-color: #ffffff;
		border-radius: 8px;
		border: 1px solid #e2e2e2;
		display: flex;
		flex-direction: column;
		&__wrapper {
			user-select: unset !important;
			display: flex;
			width: 100%;
			flex-direction: column;
			justify-content: space-around;
			&__title {
				font-family: 'Inter', sans-serif !important;
				font-weight: 700 !important;
				font-size: 14px !important;
				line-height: 100% !important;
				color: var(--username-category-title) !important;
				text-decoration: unset;
				margin-bottom: 4px;
				word-break: break-word;
				overflow-wrap: break-word;
			}
			&__date {
				font-family: 'Inter', sans-serif !important;
				font-weight: 400 !important;
				font-size: 12px !important;
				line-height: 100% !important;
				color: #9b9b9b !important;
				word-break: break-word;
				overflow-wrap: break-word;
			}
			&__description {
				font-family: 'Inter', sans-serif !important;
				font-weight: 400 !important;
				font-size: 14px !important;
				line-height: 100% !important;
				color: #4a4a4a !important;
				margin-bottom: 4px;
				word-break: break-word;
				overflow-wrap: break-word;
			}
		}
	}
}
</style>
